import React, { useEffect } from "react";
import Highcharts from "highcharts";
require("highcharts/modules/accessibility")(Highcharts);

export default function CostAnalysisGraph({ summaryReports }) {
  function applyAccessibility(chart) {
    if (chart && chart.renderTo) {
    const svg = chart.renderTo.querySelector("svg.highcharts-root");
    if (svg) {
      setTimeout(() => {
        svg.setAttribute("role", "img");
        svg.setAttribute(
        "aria-label",
        "Cost Analysis donut chart showing the distribution of quality-related costs."
        );

        const oldDesc = svg.querySelector("desc");
        if (oldDesc) oldDesc.remove();

        const desc = document.createElementNS("http://www.w3.org/2000/svg", "desc");
        desc.textContent =
        "This donut chart shows the breakdown of quality-related costs into five categories: external failures, internal failures, appraisal investments, preventive investments, and other investments.";
        svg.insertBefore(desc, svg.firstChild);
      },0);
    }
    }
  }
  var chart = {
    plotBackgroundColor: null,
    plotBorderWidth: null,
    plotShadow: false,
    events: { 
      render: function () {
          applyAccessibility(this);
      },
      redraw: function () {
          applyAccessibility(this);
      }
    }
  };
  var title = {
    text: "Cost Analysis Graph",
    align: "left",
    style: {
      fontSize: "14px",
    },
  };
  var credits = {
    enabled: false, // Disable the Highcharts bottom link
  };
  var tooltip = {
    pointFormat: "<strong>{point.percentage:.2f}%</strong>",
    borderWidth: 2,
    style: {
      borderColor: function () {
        return this.point.color; // Set the tooltip box border color to match the point color
      },
      opacity:0.9,
      fontSize:'14px',
    }
  };
  var legend = {
    enabled: false,
    align: "left",
    itemStyle: {
      fontWeight: "bold",
      fontSize: "11px",
    },
  };

  var plotOptions = {
    pie: {
      center: [null, 80],
      dataLabels: {
        enabled: false,
      },

      showInLegend: false,
      point: {
        events: {
          legendItemClick: function(e) {
              return false;
          }
        }
      }
    },
  };
  var series = [
    {
      type: "pie",
      innerSize: "30%",
      borderRadius: 0,
      data: [
        {
          name: "Cost of Appraisal  Investments",
          y: summaryReports?.FinancialAnalysis?.perCostOfAssesmentInvestment ,
          //color: "rgb(25, 73, 112)", // Set the background color for 'Ordering Cost'
          color: {
            pattern: {
              path: 'M 0 10 L 10 0',
              width: 10,
              height: 10,
              color: '#FFFFFF',
              backgroundColor: "#326289"
    
            }
          }
        },
        {
          name: "Cost of External  Failures",
          y: summaryReports?.FinancialAnalysis?.perCostOfExternalFailures,
          //color: "rgb(210, 219, 14)", // Set the background color for 'Holding Cost'
          color: {
            pattern: {
                path: 'M 0 5 L 10 5', // Horizontal line
                width: 10,
                height: 10,
                color: '#FFFFFF', // Line color (white)
                backgroundColor: '#D2DB0E' // Background color (red)
            }
          }
        },
        {
          name: "Cost of Internal  Failures",
          y: summaryReports?.FinancialAnalysis?.perCostofInternalFailure,
          //color: "rgb(80, 87, 89)", // Set the background color for 'Product Cost'
          color: {
            pattern: {
              path: 'M 0 0 L 10 10 M 0 10 L 10 0', // Diagonal cross pattern
              width: 10,
              height: 10,
              color: '#697072',   
            }
          }
        },
        {
          name: "Cost of Preventive  Investments",
          y: summaryReports?.FinancialAnalysis?.perCostOfPreventiveInvestment,
          //color: "rgb(18, 178, 166)",
          color: {
            pattern: {
              path: 'M 0 0 L 10 10 M 9 -1 L 11 1 M -1 9 L 1 11',
              width: 10,
              height: 10,
              color: '#FFFFFF',
              backgroundColor: '#2BCBBF'
            },
          }
        },
        {
          name: "Cost of Other  Investments",
          y: summaryReports?.FinancialAnalysis?.perCostOfRedHerringInvestment,
          //color: "rgb(219, 0, 32)",
          color: {
            pattern: {
              path: 'M 0 0 L 5 10 L 10 0 Z',
              width: 10,
              height: 10,
              color: '#DB0020',
            }
          }
        },
      ],
      states: {
        inactive: {
          enabled: false,
        },
      },
    },
  ];
  var accessibility = {
    enabled: true,
    screenReaderSection: {
      beforeChartFormat: '' // disables their auto "Interactive chart" label
    }
  };
  var json = {};
  json.chart = chart;
  json.credits = credits;
  json.title = title;
  json.tooltip = tooltip;
  json.legend = legend;
  json.series = series;
  json.plotOptions = plotOptions;
  json.accessibility = accessibility;
  const initGraph = () => {
    Highcharts.chart("container", json);
  };
  useEffect(() => {
    initGraph();
  }, [summaryReports]);
  return (
    <div
      id="container"
      style={{ height: "260px" }}
      title={title.text}
      aria-label="Cost Analysis Graph"
      className="costAnalysis"
    ></div>
  );
}
